export default {
  title: 'Introduceți suma rambursată',
  description: 'Disponibil pentru rambursare: {{amount}}',
  form: {
    amount: {
      label: 'Rambursare',
    },
    reason: {
      label: 'Motiv',
      options: {
        requested_by_customer: 'solicitat de client',
        reclamation: 'reclamație',
        communication_error: 'eroare de comunicare',
        other: 'altele',
      },
    },
    manual_reason: {
      label: 'Introduceți motivul rambursării',
    },
  },
  feedback: {
    amount_too_small: 'Suma minimă de rambursare {{amount}}',
    amount_too_big: 'Suma maximă de rambursare {{amount}}',
    payment_frozen:
      'Rambursare deja solicitată de client. {{provider}} este în contact cu clientul privind rambursarea',
  },
  buttons: {
    refund: 'Rambursare',
    cancel: 'Anulează',
  },
  toasts: {
    refund_successful: 'Rambursarea de {{amount}} a fost inițiată cu succes!',
  },
};
